// extracted by mini-css-extract-plugin
export default {"user-management":"user-management_user-management__EgqBF"};